/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImaginepayPaymentDetailModel } from './imaginepayPaymentDetailModel';

export interface ImaginepayPaymentTransactionModel {
  amount?: number;
  transactionReferenceNumber?: string | null;
  autoAdjustedPayment?: boolean;
  payments?: Array<ImaginepayPaymentDetailModel> | null;
  receiptEmail?: string | null;
  referrerCode?: string | null;
  dateCreated?: string | null;
  imaginePayToken?: string | null;
}
